import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
// import Wrp from '../../../hoc/Wrp/Wrp';

class RadioButton extends Component {
  
    componentDidMount(){
      // console.log(this.props);
    }
    render () {
      const {colData,id,header} = this.props;
      // console.log(id,header);
      const eventsHandler = {
        onChange:() => (colData.changeHandler) ?
                  colData.changeHandler(colData,colData.attributes):
                      'javascript(void)'
      }
      let CheckBoxes = {};
      if(colData.checked==true){
        CheckBoxes = {
          checked:true
        }
      }
      
        return(
            <td key={"column"+id} style={{minWidth:'20px'}} className="radio_td">
              {(colData.checked==true)?
                <i className="fas fa-circle" style={{fontSize:'16px',color: '#1a73e8'}}></i>
              :<i className="far fa-circle"  style={{fontSize:'16px'}}></i>}
              {/* <i className="fas fa-dot-circle-o" style={{fontSize: '15px',color: '#0c74f6'}}></i> */}
                {/* <input 
                    {...eventsHandler}
                    {...header.attributes} 
                    {...colData.attributes}
                    {...CheckBoxes}
                    className="form-radio-input" type="radio" 
                    
                    name={header.id} /> */}
            </td>
        );
    }
}

export default RadioButton;